import React from 'react';
import { Anchor, Box, Button } from 'grommet';
import { BarChart } from "grommet-icons"

const MercuryEPMetrics = ({ name }) => {
    let smokeping_host = "127.0.0.1"
    if (name.includes("ban")) {
        smokeping_host = "10.126.240.36"
    } else if (name.includes("ccu")) {
        smokeping_host = "10.126.240.42"
    } else if (name.includes("hor")) {
        smokeping_host = "10.126.240.33"
    } else if (name.includes("hyd")) {
        smokeping_host = "10.126.240.32"
    } else if (name.includes("jpr")) {
        smokeping_host = "10.126.240.36"
    } else if (name.includes("mum")) {
        smokeping_host = "10.126.240.37"
    }
    let smokeping_url = "http://" + smokeping_host + "/smokeping/sm.cgi?target=Ping"
    return (
        <Box
            justify="center"
            align="center"
            pad="none"
            gap="none"
            background="dark-2"
            alignSelf="center"
            alignContent="center"
            round="xsmall"
        >
            <Anchor alignSelf="center" margin={{ left: "6px", right: "6px" }} href={smokeping_url} target="_blank">
                <Button plain margin={{top: "xxsmall"}} hoverIndicator={{ color: "light-1", opacity: "weak" }} icon={<BarChart size="16px" color="white" />} />
            </Anchor>
        </Box>
    )
}

export default MercuryEPMetrics